import { render, staticRenderFns } from "./DeleteNodes.vue?vue&type=template&id=55ec438c&"
import script from "./DeleteNodes.vue?vue&type=script&lang=js&"
export * from "./DeleteNodes.vue?vue&type=script&lang=js&"
import style0 from "./DeleteNodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports